import { useEffect, useRef } from "react";
import { FaBolt } from "react-icons/fa";
import { GiTwoCoins } from "react-icons/gi";
import "./ReferralRewardBanner.css";

const ReferralRewardMessage = () => (
  <span className="referral-reward-banner__item">
    <FaBolt className="referral-reward-banner__bolt" aria-hidden="true" />
    <span className="referral-reward-banner__text">
      Get a <strong className="referral-reward-banner__highlight">20% Instant Referral Reward</strong> in{" "}
      <strong className="referral-reward-banner__usdt">USDT</strong>
      {" "}— Don&apos;t wait, refer now &amp; start earning!
    </span>
    <GiTwoCoins className="referral-reward-banner__coin" aria-hidden="true" />
  </span>
);

const ReferralRewardBanner = () => {
  const bannerRef = useRef(null);

  // Banner is position: fixed above the header, so header's own "top" offset
  // (and the page's --header-height-driven scroll offsets) need to know how
  // tall this banner currently is. Measuring the real rendered height here
  // keeps it correct across font loading and viewport/breakpoint changes.
  useEffect(() => {
    const bannerEl = bannerRef.current;
    if (!bannerEl || typeof ResizeObserver === "undefined") return undefined;

    const applyHeight = () => {
      document.documentElement.style.setProperty(
        "--banner-height",
        `${bannerEl.offsetHeight}px`,
      );
    };

    applyHeight();
    const observer = new ResizeObserver(applyHeight);
    observer.observe(bannerEl);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="referral-reward-banner"
      role="marquee"
      aria-label="Referral reward announcement"
      ref={bannerRef}
    >
      <div className="referral-reward-banner__track">
        {Array.from({ length: 2 }).map((_, groupIndex) => (
          <div
            className="referral-reward-banner__group"
            key={groupIndex}
            aria-hidden={groupIndex === 1}
          >
            {Array.from({ length: 4 }).map((__, itemIndex) => (
              <ReferralRewardMessage key={itemIndex} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralRewardBanner;
